import React from 'react';

import Button from '../components/Button';
import Hero from '../components/Hero';
import IndustryList from '../components/IndustryList';
import ContentBlock from '../components/ContentBlock';
import Section from '../components/Section';
import SectionHero from '../components/SectionHero';

const GraphQLHeadlessCMSBaseTemplate = ({ pageContext: { page } }) => {
  const { contentBlocks } = page;

  return (
    <React.Fragment>
      <Section>
        <Hero {...page}>
          <Button
            href="/contact"
            appearance="outline"
            colour="pink"
            size="large"
          >
            Try GraphCMS for free &#8594;
          </Button>
        </Hero>
      </Section>
      <Section colour="light">
        <SectionHero noHr title="Why GraphCMS?" />
        <IndustryList entries={contentBlocks} Component={ContentBlock} />
      </Section>
      <Section container="narrow">
        <SectionHero
          noHr
          title="Global availability"
          description="Your content and your digital assets are served from the worlds fastest and most reliable edge CDN nodes. Smart cache invalidation keeps your content fresh all the time."
        />

        <img
          src="/cdn-map.svg"
          className="max-w-full"
          alt="Content Distributed Globally Across 190 POPs"
        />
      </Section>
    </React.Fragment>
  );
};

export default GraphQLHeadlessCMSBaseTemplate;
